import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Title, Text } from 'shared/components';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import { SEGMENT_FILTER_FIELD } from '../../utils/cube/constants';
import PieChart from './PieChart';
import { ChartsRow, Container, Item, Scroller } from './styles';
import DataQualityDetails from '../DataQualityDetails';
import { getDetails } from '../../actions';
import { TitleCard, LinkMore, TitleTotal } from '../styles';

export const DataQualityCard = React.memo(({ total, nonGuess, yearsData, settings, expanded, totals }) => {
	const dispatch = useDispatch();
	const { accountId } = useSelector((state) => state.profile.me);
	const { loading, list } = useSelector((state) => state.details);
	const [ selectedSegment, setSelectedSegment ] = React.useState({});
	const [ showMore, setShowMore ] = React.useState({});

	const handleCloseMoreDetails = (id) => {
		setSelectedSegment({ ...selectedSegment, [id]: null });
	};

	const handleOnClickSegment = (segment, id) => {
		setSelectedSegment({ ...selectedSegment, [id]: null });
		setTimeout(() => {
			setSelectedSegment({ ...selectedSegment, [id]: segment });
		}, 0);
		const field = SEGMENT_FILTER_FIELD[settings.segment];
		const options = { accountId };
		options[field] = segment;
		dispatch(getDetails(options));
	};

	const handleShowMore = (blockId) => {
		const status = !(showMore[blockId]);
		return setShowMore({[blockId]: status});
	};

	// this is used to fix te total when all time is selected
	const percentage = (settings.filter === 'All time' || settings.filter === '')
		? nonGuess / totals.reports * 100
		: nonGuess / total * 100;
	const generalTotal = (settings.filter === 'All time' || settings.filter === '') ? totals.reports : totals;

	const message =
		total > 0
			? `${numeral(percentage).format(
					'0'
				)}% of programs (out of ${generalTotal}) report social impact using quality data.`
			: 'No data matching your filters, please change your card settings and try again.';

	return (
		<Container expanded={expanded}>
			<Grid container direction="row" justify="center" alignItems="center" spacing={1}>
				{total === 0 && (
					<Text style={{ width: '100%', marginTop: 160 }} centered>
						{message}
					</Text>
				)}
				{total > 0 && (
					<Grid item xs={8}>
						<TitleTotal gutterBottom>{message}</TitleTotal>
					</Grid>
				)}
				{total > 0 && (
					<Grid item xs={3} style={{ textAlign: '-webkit-center' }}>
						<PieChart total={total} nonGuess={nonGuess} />
					</Grid>
				)}
			</Grid>
			{total > 0 &&
				yearsData.map((year, i) => (
					<ChartsRow key={i}>
						<TitleCard>
							{ year.title }
						</TitleCard>
						{year.rows.length > 0 && (
							<Scroller>
								{(showMore[year.title] ? year.rows : year.rows.slice(0, 6)).map((row, idx) => (
									<Item key={idx} onClick={() => handleOnClickSegment(row.title, i)}>
										<PieChart {...row} />
									</Item>
								))}
								{year.rows.length > 6 &&
								!showMore[year.title] && (
									<LinkMore onClick={() => handleShowMore(year.title)}>
										Show {year.rows.length - 6} more...
									</LinkMore>
								)}
								{showMore[year.title] && (<LinkMore onClick={() => handleShowMore(year.title)}>Show Less</LinkMore>)}
							</Scroller>
						)}
						{year.rows.length === 0 && <Text>There is no data for this year</Text>}
						{selectedSegment &&
						selectedSegment[i] && (
							<DataQualityDetails
								loading={loading}
								list={list}
								onClose={() => handleCloseMoreDetails(i)}
							/>
						)}
					</ChartsRow>
				))}
		</Container>
	);
});

DataQualityCard.propTypes = {
	total: PropTypes.number,
	nonGuess: PropTypes.number,
	yearsData: PropTypes.array,
	settings: PropTypes.object
};
